import React from 'react';
import LogoutConfirmationIcon from '../../../svgs/LogoutConfirmationIcon';
import ModalFormComp from '../../ModalFormComp';

import './logOutAdmin.scss';

interface ILogout{
  closeModal?:any;
  logout?:any;
}
const LogOutAdmin = ({
  closeModal, logout,
}:ILogout) => (
  <div>
    <ModalFormComp
      confirmationBtnContent="Logout"
      cancelActionBtn={closeModal}
      closeModal={closeModal}
      removeTitle
      hasCancel
      modalType="admin-logout-confirmation-modal"
      confirmActionBtn={() => logout()}
      confirmationIcon={<LogoutConfirmationIcon />}
      confirmationSubTitle="Are you sure you want to logout of the admin portal?"
      confirmationTitle="Logout"
    />
  </div>
);
export default LogOutAdmin;
